<script>
	import Demon from "./Demon.svelte";
	import Title from "./Title.svelte";
	import { Route, Router, router, navigateTo, Link } from "yrv";
	import PrintLetter from "./PrintLetter.svelte";
	import DemonCode from "./DemonCode.svelte";
	import chroma from "chroma-js";
	import Sins from "./Components/Sins.svelte";


	import Navigation from "./Components/Navigation.svelte";

	let showDownloads = true;

	Router.hashchange = true;

	router.subscribe((e) => {
		// if (!e.initial) console.log(e);
	});

	function handleMessage(event) {
		navigateTo("/" + event.detail.hash, "reload");
	}

	function parseDemon(demoncode) {
		/* check to see if URL paramaters are encoded */
		var demoncode;

		try {
			demoncode = decodeURI(atob(demoncode));
		} catch (error) {
			demoncode = demoncode;
		}

		var color = demoncode.split("-")[1];
		var fname = demoncode.split("-")[2];
		var lname = demoncode.split("-")[3];
		var symbol = demoncode.split("-")[4];
		var code = demoncode.split("-")[0].split("");

		//chin+ear+face+paint+mouth+tongue+horn+eye+nose+hair;

		// console.log("color:#" + color);
		// console.log("demoncode:" + demoncode);
		return {
			demoncode: demoncode,
			baseColor: "#" + color,
			chin: code[0],
			ear: code[1],
			face: code[2],
			paint: code[3],
			mouth: code[4],
			horn: code[5],
			eye: code[6],
			nose: code[7],
			hair: code[8],
			bgcode: code[9],
			sleep: code[10],
			body: code[11],
			logo: code[12],
			colorshift: code.length > 13 ? code[13] : "1",
			bgcolorshift: code.length > 13 ? code[14] : "1",
			fname: fname,
			lname: lname,
			symbol: symbol,
		};
	}

	function randomNumber() {
		return Math.floor(Math.random() * 360);
	}

	function randomColor() {
		return replaceHexHash(chroma.hsl(randomNumber(), 0.4, 0.7).hex());
	}

	function replaceHexHash(str) {
		return str.replace("#", "");
	}

	

	// scripts to return the most frequent letter/alignment to associate with different sins

	function getTopSins(hash) {
		var str =
			hash.split("-")[0].replace(new RegExp("[0-9]", "g"), "") +
			hash.split("-")[2] +
			hash.split("-")[3];
		// console.log(str)
		var sins = getFrequency(str);
		var deadlySins = Object.entries(sins).sort(([, a], [, b]) => b - a);
		var topSins = [deadlySins[0][0], deadlySins[1][0], deadlySins[2][0]];
		return topSins;
	}

	function getFrequency(str) {
		return str
			.replaceAll("-", "")
			.toUpperCase()
			.split("")
			.reduce((prev, curr) => {
				prev[curr] = prev[curr] ? prev[curr] + 1 : 1;
				return prev;
			}, {});
	}
</script>

<!-- <div class="demon" style="width:50%;">
	<Demon edit={true} />			
</div> -->

<div class="max-w-screen-2xl  m-auto">
	{#if $router.path != "/showcase"}
		<div class="p-16">
			<Navigation />
			<!-- <Title fill="#000" />	 -->
			<!-- {#if $router.path== "/"}
		<p class="pt-6"><strong>Face Your Demons</strong> is an art project by John Dilworth based on depictions of evil in cultures around the world.
			Each of these whimsical and grotesque images is unique and generated by combining hundreds of unique elements, colors, patterns and generated designs created by the artist.</p>
		{/if} -->
		</div>
	{/if}

	<Router>
		<Route path="/wallet">
			<Wallet/>
		</Route>
		<Route exact="/">
			<div
				class="grid grid-cols-1 md:grid-cols-3 gap-0 md:gap-0 px-12 pb-6"
			>
				{#each Array(12) as _, i}
					<div class="col-span-1">
						<div>
							<Demon
								w="400"
								h="600"
								dw="175.52"
								dh="233"
								dx="113"
								dy="160"
								ds="1"
								scalable={true}
								edit={false}
								on:message={handleMessage}
								randomize={false}
								showbuylink={false}
							/>
						</div>
					</div>
				{/each}

				<div class="col-span-1 md:col-span-2">
					<p class="text-sm pb-4">
						“Sometimes we have the absolute certainty there's
						something inside us that's so hideous and monstrous that
						if we ever search it out we won't be able to stand
						looking at it. But it's when we're willing to come face
						to face with that demon that we face the angel.”<span
							class="italic">—Hubert Selby, Jr.</span
						>
					</p>
				</div>
				<p class="col-span-1 md:col-span-1">
					<a href="/" class="flex space-x-2 items-center">
						<span>
							<svg
								viewBox="0 0 20 20"
								height="20"
								width="20"
								xmlns="http://www.w3.org/2000/svg"
								><g
									transform="matrix(0.8333333333333334,0,0,0.8333333333333334,0,0)"
									><path
										d="M10.664,20.073a1.249,1.249,0,1,0-.507,2.447A10.739,10.739,0,1,0,2.4,16.1a.25.25,0,0,1-.084.3l-1,.726a1,1,0,0,0,.377,1.787l3.946.849a1.062,1.062,0,0,0,.21.022,1,1,0,0,0,.978-.79l.945-4.4a1,1,0,0,0-1.565-1.02l-1.361.989a.25.25,0,0,1-.386-.128,8.255,8.255,0,1,1,6.205,5.643Z"
										fill="#000000"
										stroke="none"
										stroke-linecap="round"
										stroke-linejoin="round"
									/></g
								></svg
							>
						</span>

						<span>Refresh to see more</span></a
					>
				</p>
			</div>
		</Route>

		<Route path="/about">
			<div class="grid grid-cols-3 gap-12 p-12 -mb-12">
				<div class="col-span-2">
					<p class="pb-4 text-xl">
						<strong>Guardian Demons</strong> is a unique art collection
						based on depictions of evil in cultures around the world.
					</p>

					<p class="pb-4 text-xl">
						These whimsical and grotesque images are generated by
						combining hundreds of unique elements, colors, patterns
						and randomly generated designs created by the artist.
					</p>
					<p class="pb-4 text-xl">
						The portraits do not represent evil, but rather are
						intended to ward off evil like gargoyles on a cathedral.
					</p>
					<p class="pb-4 text-xl">
						Hang a portrait in your home as a reminder that you have
						the power to overcome your personal demons no matter how
						many or how frightening they might be.
					</p>
				</div>
				<div class="col-span-1">
					<p class="text-sm mb-6">
						The combination of elements results in over 100 trillion
						possible permutations.
					</p>
					<div>
					<Demon scalable={true} randomize={false} showbg={true} />
					</div>
				</div>
			</div>
		</Route>

		<Route path="/primes">
			<div class="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-4">
				<Demon
					scalable={true}
					{...parseDemon(
						"AAAAAAAAAA1T-" + randomColor() + "-prime-a"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"BBBBBBBBBB1T-" + randomColor() + "-prime-b"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"CCCCCCCCCC1T-" + randomColor() + "-prime-c"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"DDDDDDDDDD1T-" + randomColor() + "-prime-d"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"EEEEEEEEEE1T-" + randomColor() + "-prime-e"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"FFFFFFFFFF1T-" + randomColor() + "-prime-f"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"GGGGGGGGGG1T-" + randomColor() + "-prime-g"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"HHHHHHHHHH1T-" + randomColor() + "-prime-h"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"IIIIIIIIII1T-" + randomColor() + "-prime-i"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"JJJJJJJJJJ1T-" + randomColor() + "-prime-j"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"KKKKKKKKKK1T-" + randomColor() + "-prime-k"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"LLLLLLLLLL1T-" + randomColor() + "-prime-l"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"MMMMMMMMMM1T-" + randomColor() + "-prime-m"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"NNNNNNNNNN1T-" + randomColor() + "-prime-n"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"OOOOOOOOOO1T-" + randomColor() + "-prime-o"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"PPPPPPPPPP1T-" + randomColor() + "-prime-p"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"QQQQQQQQQQ1T-" + randomColor() + "-prime-q"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"RRRRRRRRRR1T-" + randomColor() + "-prime-r"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"SSSSSSSSSS1T-" + randomColor() + "-prime-s"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"TTTTTTTTTT1T-" + randomColor() + "-prime-t"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"UUUUUUUUUU1T-" + randomColor() + "-prime-u"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"VVVVVVVVVV1T-" + randomColor() + "-prime-v"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"WWWWWWWWWW1T-" + randomColor() + "-prime-w"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"XXXXXXXXXX1T-" + randomColor() + "-prime-x"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"YYYYYYYYYY1T-" + randomColor() + "-prime-y"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"ZZZZZZZZZZ1T-" + randomColor() + "-prime-z"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"ZZZZZZZZZ11T-" + randomColor() + "-prime-z"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"ZZZZZZZZZ21T-" + randomColor() + "-prime-z"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"ZZZZZZZZZ31T-" + randomColor() + "-prime-z"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"ZZZZZZZZZ41T-" + randomColor() + "-prime-z"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"ZZZZZZZZZ51T-" + randomColor() + "-prime-z"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"ZZZZZZZZZ61T-" + randomColor() + "-prime-z"
					)}
				/>
				<Demon
					scalable={true}
					{...parseDemon(
						"ZZZZZZZZZ71T-" + randomColor() + "-prime-z"
					)}
				/>
			</div>
		</Route>

		<Route path="/showcase" let:router>
			<div class="flex h-screen items-center align-middle py-24 bg-black">
				<Demon scalable={true} randomize={true} />
			</div>
		</Route>

		<Route path="/backgroundonly/:id" let:router>
			<div class="flex h-screen items-center align-middle">
				<Demon
					showbg={true}
					showdemon={false}
					w="400"
					h="600"
					ds="1"
					dw="173.52"
					dh="233"
					dx="113"
					dy="160"
					scalable={true}
					{...parseDemon(router.params.id)}
				/>
				<!-- NFT -->
				<PrintLetter
					w="4040"
					h="6060"
					dx="0"
					dy="0"
					qrx="0"
					qry="0"
					namex="0"
					namey="0"
					buttonName="High Resolution/No Border"
					fileName={router.params.id}
					{...parseDemon(router.params.id)}
				>
					<g slot="demon">
						<Demon
							showdemon={false}
							w="4040"
							h="6060"
							ds="1"
							dw="1782"
							dh="2400"
							dx="1130"
							dy="1594.4"
							{...parseDemon(router.params.id)}
						/>
					</g>
				</PrintLetter>
			</div>
		</Route>

		<Route path="/demononly/:id" let:router>
			<div class="flex h-screen items-center align-middle">
				<Demon
					showbg={false}
					showdemon={true}
					w="400"
					h="600"
					ds="1"
					dw="173.52"
					dh="233"
					dx="113"
					dy="160"
					scalable={true}
					{...parseDemon(router.params.id)}
				/>
				<!-- NFT -->
				<PrintLetter
					w="4040"
					h="6060"
					dx="0"
					dy="0"
					qrx="0"
					qry="0"
					namex="0"
					namey="0"
					buttonName="High Resolution/No Border"
					fileName={router.params.id}
					{...parseDemon(router.params.id)}
					showbg={false}
				>
					<g slot="demon">
						<Demon
							showdemon={true}
							showbg={false}
							w="4040"
							h="6060"
							ds="1"
							dw="1782"
							dh="2400"
							dx="1130"
							dy="1594.4"
							{...parseDemon(router.params.id)}
						/>
					</g>
				</PrintLetter>
			</div>
		</Route>

		<Route path="/success/:id" let:router>
			<div class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-12 px-12">
				<div class="md:col-span-1">
					<div class="frame ">
						<div class="mat">
							<div class="art innershadow">
								<Demon
									showbg={true}
									w="400"
									h="600"
									ds="1"
									dw="173.52"
									dh="233"
									dx="113"
									dy="160"
									scalable={true}
									{...parseDemon(router.params.id)}
								/>
							</div>
						</div>
					</div>
				</div>
				<div class="md:col-span-2">
					<p class="text-xl font-bold mb-4">
						Thank you for your purchase!
					</p>
					<p class="text-lg">
						You will receive a confirmation email with expected
						delivery times. Orders are printed on-demand. Postcards
						may take up to 6 weeks for delivery.
					</p>
				</div>
			</div>
		</Route>

		<Route path="/customize/:id" let:router>
			{parseDemon(router.params.id).colorshift}{parseDemon(
				router.params.id
			).bgcolorshift}
			<div class="flex h-screen items-center align-middle py-24">
				
				<Demon
					scalable={true}
					edit={true}
					randomize={false}
					{...parseDemon(router.params.id)}
				/>
				
			</div>
		</Route>

		<Route path="/:id" let:router>
			<div
				class="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-12 px-12 mb-12"
			>
				<div class="col-span-2">
					<Demon
						showbg={true}
						w="400"
						h="600"
						ds="1"
						dw="173.52"
						dh="233"
						dx="113"
						dy="160"
						scalable={true}
						{...parseDemon(router.params.id)}
					/>
				</div>

				<div class="col-span-1">
					<h3 class="text-xs uppercase m-0 p-0 text-gray">
						Demon Name
					</h3>
					<h2
						class="text-3xl uppercase font-bold text-left tracking-widest mt-0 mb-2"
						style="color:{chroma(
							parseDemon(router.params.id).baseColor
						).darken(3)}"
					>
						{parseDemon(router.params.id).fname}
						{parseDemon(router.params.id).lname}
					</h2>

					<p class="pb-4">
						<strong class="capitalize"
							>{parseDemon(router.params.id).fname}
							{parseDemon(router.params.id).lname}</strong
						>
						is a friendly demon that protects you from the evils of
						<strong class="lowercase"
							><Sins
								sin={getTopSins(router.params.id)[0]}
								list={parseDemon(router.params.id).sleep}
							/></strong
						>,
						<strong class="lowercase"
							><Sins
								sin={getTopSins(router.params.id)[1]}
								list={parseDemon(router.params.id).sleep}
							/></strong
						>, and
						<strong class="lowercase"
							><Sins
								sin={getTopSins(router.params.id)[2]}
								list={parseDemon(router.params.id).sleep}
							/></strong
						>.
					</p>

					<p class="pb-4">
						Each guardian demon is created by combining hundreds of
						unique elements, colors, patterns and randomly generated
						designs. The demons do not represent evil, but rather
						ward off evil like gargoyles on a cathedral.
					</p>

					<p class="pb-4">
						Collect a demon to protect you against evil and to
						remind you that you can overcome your personal demons no
						matter how many or how frightening they might be.
					</p>

					<!-- <h2>Traits</h2>


				
<!-- <p class="pb-4 break-all">https://demons.johndilworth.com/#/{encodeURI(btoa(router.params.id))}</p> -->

					<p class="break-all">
						<a
							href="https://demons.johndilworth.com/#/{btoa(
								encodeURI(router.params.id)
							)}"
							>https://demons.johndilworth.com/#/{btoa(
								encodeURI(router.params.id)
							)}</a
						>
					</p>

					<div class="printables mt-6">
						{#if showDownloads == true}
							<h3
								class="text-xs uppercase m-0 p-0 text-gray mb-4"
							>
								Downloads
							</h3>

							<div class="space-y-1">
								<div style="">
									<!-- post cards -->
									<PrintLetter
										w="1188"
										h="1836"
										dx="144"
										dy="144"
										qrx="144"
										qry="1536"
										namex="324"
										namey="1570"
										fontsize="24"
										buttonName="Half Page Postcard"
										scalable={false}
										fileName={router.params.id}
										display={false}
										{...parseDemon(router.params.id)}
									>
										<g slot="demon">
											<Demon
												w="900"
												h="1350"
												ds="1"
												dw="390.42"
												dh="524.25"
												dx="254.24"
												dy="360"
												scalable={false}
												{...parseDemon(
													router.params.id
												)}
											/>
										</g>
										<g slot="cover" />
										<g slot="qr">
											<DemonCode
												qrSize="150"
												{...parseDemon(
													router.params.id
												)}
											/>
										</g>
									</PrintLetter>

									<!-- 13x19 -->
									<PrintLetter
										w="2808"
										h="4104"
										dx="394"
										dy="394"
										qrx="394"
										qry="3464"
										namex="620"
										namey="3510"
										fontsize="36"
										buttonName="13x19 Print"
										fileName={router.params.id}
										display={false}
										{...parseDemon(router.params.id)}
									>
										<g slot="demon">
											<Demon
												w="2020"
												h="3030"
												ds="1"
												dw="891"
												dh="1200"
												dx="565"
												dy="797.2"
												{...parseDemon(
													router.params.id
												)}
											/>
										</g>
										<g slot="qr">
											<DemonCode
												qrSize="200"
												{...parseDemon(
													router.params.id
												)}
											/>
										</g>
									</PrintLetter>

									<!-- 8.5x11 print -->

									<PrintLetter
										w="1836"
										h="2376"
										dx="453"
										dy="453"
										qrx="453"
										qry="1933"
										namex="623"
										namey="1968"
										buttonName="8.5x11 Print"
										fontsize="24"
										fileName={router.params.id}
										display={false}
										{...parseDemon(router.params.id)}
									>
										<g slot="demon">
											<Demon
												w="960"
												h="1440"
												ds="1"
												dw="416.45"
												dh="559.2"
												dx="271.2"
												dy="384"
												{...parseDemon(
													router.params.id
												)}
											/>
										</g>
										<g slot="qr">
											<g transform="translate(-100 -30)">
												<rect
													width="100%"
													height="500"
													fill="white"
												/>
											</g>
											<DemonCode
												qrSize="150"
												{...parseDemon(
													router.params.id
												)}
											/>
										</g>
									</PrintLetter>
									<!-- 24x36 inch poster -->
									<PrintLetter
										w="5184"
										h="7776"
										dx="572"
										dy="572"
										qrx="572"
										qry="6730"
										namex="900"
										namey="6810"
										display={false}
										buttonName="24x36 Poster "
										fileName={router.params.id}
										backgroundColor="#fff"
										fontsize="72"
										scalable={false}
										{...parseDemon(router.params.id)}
									>
										<g slot="demon">
											<Demon
												w="4040"
												h="6060"
												ds="1"
												dw="1782"
												dh="2400"
												dx="1130"
												dy="1594.4"
												{...parseDemon(
													router.params.id
												)}
											/>
										</g>
										<g slot="qr">
											<DemonCode
												qrSize="300"
												{...parseDemon(
													router.params.id
												)}
											/>
										</g>
									</PrintLetter>
								</div>
								<!-- instagram story -->
								<PrintLetter
									w="1080"
									h="1920"
									dx="0"
									dy="0"
									qrx="0"
									qry="1620"
									namex="20"
									namey="2000"
									buttonName="Instagram Story"
									fileName={router.params.id}
									{...parseDemon(router.params.id)}
								>
									<g slot="demon">
										<Demon
											w="1080"
											h="1620"
											ds="1"
											dw="476.38"
											dh="641.67"
											dx="302.08"
											dy="426.23"
											{...parseDemon(router.params.id)}
										/>
									</g>
									<g slot="qr">
										<svg
											width="1080"
											height="300"
											viewBox="0 0 1080 300"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<rect
												width="1080"
												height="300"
												fill="white"
											/>
											<path
												d="M129.588 150.471V128.507H120.062V144.561C117.415 145.179 114.857 145.531 112.123 145.531C102.243 145.531 93.775 137.945 93.775 127.448C93.775 116.775 102.684 109.277 112.828 109.277C118.827 109.277 124.296 111.217 129.588 113.776V104.337C127.824 103.631 121.561 100.897 111.682 100.897C96.7741 100.897 83.4544 112.011 83.4544 127.536C83.4544 143.061 96.8624 154 111.682 154C122.179 154 127.912 151.177 129.588 150.471ZM195.826 152.5V102.396H186.3V138.21L164.071 142.797V102.396H154.544V154L186.3 146.766V152.5H195.826ZM263.061 152.5L243.655 102.396H235.451L216.045 152.5H263.061ZM250.447 145.179H228.659L239.509 114.393L250.447 145.179ZM324.962 147.913L321.61 144.561C320.639 145.443 319.757 146.061 318.434 146.061C316.582 146.061 315.17 144.473 314.288 143.15L307.584 133.623H315.964V102.396H283.238V152.5H292.765V133.623H296.999L305.467 146.766C308.466 151.441 311.995 153.382 316.317 153.382C321.61 153.382 324.432 148.619 324.962 147.913ZM306.879 126.213H292.765V110.247H306.879V126.213ZM389.785 127.625C389.785 111.394 375.319 102.396 360.588 102.396H344.269V152.5H361.029C375.672 152.5 389.785 144.032 389.785 127.625ZM379.906 127.625C379.906 137.769 372.143 143.944 361.205 143.944H353.795V110.776H360.852C371.702 110.776 379.906 117.569 379.906 127.625ZM422.762 152.5V102.396H413.235V152.5H422.762ZM490.386 152.5L470.98 102.396H462.776L443.37 152.5H490.386ZM477.772 145.179H455.984L466.834 114.393L477.772 145.179ZM553.257 152.5V118.98C553.257 107.601 547.082 100.897 536.056 100.897C531.116 100.897 526.705 102.661 522.648 105.396C521.766 106.101 520.972 106.631 520.09 107.248L519.737 102.396H510.563V152.5H520.09V116.422C520.707 115.893 521.413 115.275 522.295 114.569C526 111.659 530.41 109.63 535.262 109.63C540.466 109.63 543.73 112.364 543.73 119.156V152.5H553.257ZM653.245 127.625C653.245 111.394 638.779 102.396 624.048 102.396H607.729V152.5H624.489C639.132 152.5 653.245 144.032 653.245 127.625ZM643.366 127.625C643.366 137.769 635.603 143.944 624.665 143.944H617.256V110.776H624.312C635.162 110.776 643.366 117.569 643.366 127.625ZM707.745 152.5V144.12H685.781V131.329H701.306V123.038H685.781V110.776H706.598V102.396H676.254V152.5H707.745ZM799.542 152.5V117.833C799.542 107.072 792.661 100.897 784.37 100.897C780.312 100.897 776.872 102.132 774.225 103.631C772.902 104.425 771.756 105.219 770.785 105.925C769.815 106.631 769.197 107.248 768.492 107.865C767.786 107.16 767.257 106.454 766.639 105.748C765.934 105.043 765.14 104.249 764.169 103.543C762.229 102.044 759.494 100.897 755.348 100.897C750.409 100.897 746.175 102.573 742.47 105.572C741.676 106.189 741.058 106.719 740.264 107.336L739.912 102.396H730.738V152.5H740.264V116.157C740.705 115.716 741.323 115.187 742.117 114.481C745.292 111.835 749.262 109.63 753.584 109.63C758.259 109.63 761.17 112.364 761.17 119.156V152.5H770.697V117.833C770.697 116.951 770.609 116.069 770.521 115.187C771.403 114.569 772.991 113.246 775.108 112.011C777.225 110.776 779.783 109.63 782.605 109.63C787.457 109.63 790.015 113.07 790.015 118.098V152.5H799.542ZM868.587 152.5V102.396H825.364V152.5H868.587ZM859.061 144.473H834.891V110.424H859.061V144.473ZM852.798 127.448L846.976 121.626L841.154 127.448L846.976 133.27L852.798 127.448ZM937.1 152.5V118.98C937.1 107.601 930.925 100.897 919.899 100.897C914.959 100.897 910.549 102.661 906.491 105.396C905.609 106.101 904.815 106.631 903.933 107.248L903.58 102.396H894.406V152.5H903.933V116.422C904.55 115.893 905.256 115.275 906.138 114.569C909.843 111.659 914.253 109.63 919.105 109.63C924.309 109.63 927.573 112.364 927.573 119.156V152.5H937.1ZM997.598 143.855L971.488 111.659C972.282 111.217 975.898 109.365 981.632 109.365C988.865 109.365 994.511 112.011 996.01 112.717V103.808C994.863 103.19 989.218 100.897 981.72 100.897C967.695 100.897 960.461 109.718 959.05 111.217L984.896 143.061C983.396 143.679 979.691 145.531 974.575 145.531C967.783 145.531 962.137 142.797 960.02 142.003V151.089C961.608 151.706 966.812 154 974.575 154C989.13 154 996.628 144.914 997.598 143.855Z"
												fill="black"
											/>
											<path
												d="M123.975 213.833V206.612H120.843V211.89C119.973 212.093 119.132 212.209 118.233 212.209C114.985 212.209 112.201 209.715 112.201 206.264C112.201 202.755 115.13 200.29 118.465 200.29C120.437 200.29 122.235 200.928 123.975 201.769V198.666C123.395 198.434 121.336 197.535 118.088 197.535C113.187 197.535 108.808 201.189 108.808 206.293C108.808 211.397 113.216 214.993 118.088 214.993C121.539 214.993 123.424 214.065 123.975 213.833ZM145.751 214.5V198.028H142.619V209.802L135.311 211.31V198.028H132.179V214.993L142.619 212.615V214.5H145.751ZM167.855 214.5L161.475 198.028H158.778L152.398 214.5H167.855ZM163.708 212.093H156.545L160.112 201.972L163.708 212.093ZM188.205 212.992L187.103 211.89C186.784 212.18 186.494 212.383 186.059 212.383C185.45 212.383 184.986 211.861 184.696 211.426L182.492 208.294H185.247V198.028H174.488V214.5H177.62V208.294H179.012L181.796 212.615C182.782 214.152 183.942 214.79 185.363 214.79C187.103 214.79 188.031 213.224 188.205 212.992ZM182.26 205.858H177.62V200.609H182.26V205.858ZM209.517 206.322C209.517 200.986 204.761 198.028 199.918 198.028H194.553V214.5H200.063C204.877 214.5 209.517 211.716 209.517 206.322ZM206.269 206.322C206.269 209.657 203.717 211.687 200.121 211.687H197.685V200.783H200.005C203.572 200.783 206.269 203.016 206.269 206.322ZM220.358 214.5V198.028H217.226V214.5H220.358ZM242.59 214.5L236.21 198.028H233.513L227.133 214.5H242.59ZM238.443 212.093H231.28L234.847 201.972L238.443 212.093ZM263.259 214.5V203.48C263.259 199.739 261.229 197.535 257.604 197.535C255.98 197.535 254.53 198.115 253.196 199.014C252.906 199.246 252.645 199.42 252.355 199.623L252.239 198.028H249.223V214.5H252.355V202.639C252.558 202.465 252.79 202.262 253.08 202.03C254.298 201.073 255.748 200.406 257.343 200.406C259.054 200.406 260.127 201.305 260.127 203.538V214.5H263.259ZM286.716 206.322C286.716 200.986 281.96 198.028 277.117 198.028H271.752V214.5H277.262C282.076 214.5 286.716 211.716 286.716 206.322ZM283.468 206.322C283.468 209.657 280.916 211.687 277.32 211.687H274.884V200.783H277.204C280.771 200.783 283.468 203.016 283.468 206.322ZM304.633 214.5V211.745H297.412V207.54H302.516V204.814H297.412V200.783H304.256V198.028H294.28V214.5H304.633ZM334.812 214.5V203.103C334.812 199.565 332.55 197.535 329.824 197.535C328.49 197.535 327.359 197.941 326.489 198.434C326.054 198.695 325.677 198.956 325.358 199.188C325.039 199.42 324.836 199.623 324.604 199.826C324.372 199.594 324.198 199.362 323.995 199.13C323.763 198.898 323.502 198.637 323.183 198.405C322.545 197.912 321.646 197.535 320.283 197.535C318.659 197.535 317.267 198.086 316.049 199.072C315.788 199.275 315.585 199.449 315.324 199.652L315.208 198.028H312.192V214.5H315.324V202.552C315.469 202.407 315.672 202.233 315.933 202.001C316.977 201.131 318.282 200.406 319.703 200.406C321.24 200.406 322.197 201.305 322.197 203.538V214.5H325.329V203.103C325.329 202.813 325.3 202.523 325.271 202.233C325.561 202.03 326.083 201.595 326.779 201.189C327.475 200.783 328.316 200.406 329.244 200.406C330.839 200.406 331.68 201.537 331.68 203.19V214.5H334.812ZM357.511 214.5V198.028H343.301V214.5H357.511ZM354.379 211.861H346.433V200.667H354.379V211.861ZM352.32 206.264L350.406 204.35L348.492 206.264L350.406 208.178L352.32 206.264ZM380.035 214.5V203.48C380.035 199.739 378.005 197.535 374.38 197.535C372.756 197.535 371.306 198.115 369.972 199.014C369.682 199.246 369.421 199.42 369.131 199.623L369.015 198.028H365.999V214.5H369.131V202.639C369.334 202.465 369.566 202.262 369.856 202.03C371.074 201.073 372.524 200.406 374.119 200.406C375.83 200.406 376.903 201.305 376.903 203.538V214.5H380.035ZM399.925 211.658L391.341 201.073C391.602 200.928 392.791 200.319 394.676 200.319C397.054 200.319 398.91 201.189 399.403 201.421V198.492C399.026 198.289 397.17 197.535 394.705 197.535C390.094 197.535 387.716 200.435 387.252 200.928L395.749 211.397C395.256 211.6 394.038 212.209 392.356 212.209C390.123 212.209 388.267 211.31 387.571 211.049V214.036C388.093 214.239 389.804 214.993 392.356 214.993C397.141 214.993 399.606 212.006 399.925 211.658ZM410.889 212.731L408.627 210.469L406.365 212.731L408.627 214.993L410.889 212.731ZM432.842 213.833V210.788C432.175 211.049 429.971 212.209 427.1 212.209C423.852 212.209 421.068 209.715 421.068 206.264C421.068 202.755 423.997 200.29 427.332 200.29C429.942 200.29 432.204 201.45 432.842 201.769V198.666C432.262 198.434 430.203 197.535 426.955 197.535C422.054 197.535 417.675 201.189 417.675 206.293C417.675 211.397 422.083 214.993 426.955 214.993C430.406 214.993 432.291 214.065 432.842 213.833ZM454.633 214.5V198.028H440.423V214.5H454.633ZM451.501 211.861H443.555V200.667H451.501V211.861ZM449.442 206.264L447.528 204.35L445.614 206.264L447.528 208.178L449.442 206.264ZM485.741 214.5V203.103C485.741 199.565 483.479 197.535 480.753 197.535C479.419 197.535 478.288 197.941 477.418 198.434C476.983 198.695 476.606 198.956 476.287 199.188C475.968 199.42 475.765 199.623 475.533 199.826C475.301 199.594 475.127 199.362 474.924 199.13C474.692 198.898 474.431 198.637 474.112 198.405C473.474 197.912 472.575 197.535 471.212 197.535C469.588 197.535 468.196 198.086 466.978 199.072C466.717 199.275 466.514 199.449 466.253 199.652L466.137 198.028H463.121V214.5H466.253V202.552C466.398 202.407 466.601 202.233 466.862 202.001C467.906 201.131 469.211 200.406 470.632 200.406C472.169 200.406 473.126 201.305 473.126 203.538V214.5H476.258V203.103C476.258 202.813 476.229 202.523 476.2 202.233C476.49 202.03 477.012 201.595 477.708 201.189C478.404 200.783 479.245 200.406 480.173 200.406C481.768 200.406 482.609 201.537 482.609 203.19V214.5H485.741ZM510.983 206.206L506.981 202.175L502.95 206.206L506.981 210.237L510.983 206.206ZM542.583 212.905L541.278 211.629C541.133 211.803 540.814 212.209 540.292 212.209C539.828 212.209 539.422 211.89 538.929 211.426L533.854 206.351L542.177 198.028H538.523L531.331 205.278V198.028H528.199V214.5H531.331V207.888L536.435 213.166C537.247 214.007 538.117 214.79 539.683 214.79C541.423 214.79 542.409 213.137 542.583 212.905ZM563.262 214.5V203.48C563.262 199.739 561.232 197.535 557.607 197.535C555.983 197.535 554.533 198.115 553.199 199.014C552.909 199.246 552.648 199.42 552.358 199.623L552.242 198.028H549.226V214.5H552.358V202.639C552.561 202.465 552.793 202.262 553.083 202.03C554.301 201.073 555.751 200.406 557.346 200.406C559.057 200.406 560.13 201.305 560.13 203.538V214.5H563.262ZM585.964 214.5V198.028H571.754V214.5H585.964ZM582.832 211.861H574.886V200.667H582.832V211.861ZM580.773 206.264L578.859 204.35L576.945 206.264L578.859 208.178L580.773 206.264ZM607.357 200.754V198.028H592.596V200.754H598.396V214.5H601.557V200.754H607.357ZM624.389 206.148L627.695 198.028H624.65L622.997 202.523L621.344 198.028H618.299L621.605 206.148L620.097 210.005L615.486 198.028H612.151L618.821 214.5H620.88L622.997 209.251L625.114 214.5H627.173L633.843 198.028H630.508L625.897 210.005L624.389 206.148ZM654.682 214.5V198.028H640.472V214.5H654.682ZM651.55 211.861H643.604V200.667H651.55V211.861ZM649.491 206.264L647.577 204.35L645.663 206.264L647.577 208.178L649.491 206.264ZM676.887 212.992L675.785 211.89C675.466 212.18 675.176 212.383 674.741 212.383C674.132 212.383 673.668 211.861 673.378 211.426L671.174 208.294H673.929V198.028H663.17V214.5H666.302V208.294H667.694L670.478 212.615C671.464 214.152 672.624 214.79 674.045 214.79C675.785 214.79 676.713 213.224 676.887 212.992ZM670.942 205.858H666.302V200.609H670.942V205.858ZM697.618 212.905L696.313 211.629C696.168 211.803 695.849 212.209 695.327 212.209C694.863 212.209 694.457 211.89 693.964 211.426L688.889 206.351L697.212 198.028H693.558L686.366 205.278V198.028H683.234V214.5H686.366V207.888L691.47 213.166C692.282 214.007 693.152 214.79 694.718 214.79C696.458 214.79 697.444 213.137 697.618 212.905ZM716.955 214.5V198.028H713.823V214.5H716.955ZM739.622 214.5V203.48C739.622 199.739 737.592 197.535 733.967 197.535C732.343 197.535 730.893 198.115 729.559 199.014C729.269 199.246 729.008 199.42 728.718 199.623L728.602 198.028H725.586V214.5H728.718V202.639C728.921 202.465 729.153 202.262 729.443 202.03C730.661 201.073 732.111 200.406 733.706 200.406C735.417 200.406 736.49 201.305 736.49 203.538V214.5H739.622ZM763.078 206.322C763.078 200.986 758.322 198.028 753.479 198.028H748.114V214.5H753.624C758.438 214.5 763.078 211.716 763.078 206.322ZM759.83 206.322C759.83 209.657 757.278 211.687 753.682 211.687H751.246V200.783H753.566C757.133 200.783 759.83 203.016 759.83 206.322ZM784.214 214.5V198.028H781.082V209.802L773.774 211.31V198.028H770.642V214.993L781.082 212.615V214.5H784.214ZM804.114 211.658L795.53 201.073C795.791 200.928 796.98 200.319 798.865 200.319C801.243 200.319 803.099 201.189 803.592 201.421V198.492C803.215 198.289 801.359 197.535 798.894 197.535C794.283 197.535 791.905 200.435 791.441 200.928L799.938 211.397C799.445 211.6 798.227 212.209 796.545 212.209C794.312 212.209 792.456 211.31 791.76 211.049V214.036C792.282 214.239 793.993 214.993 796.545 214.993C801.33 214.993 803.795 212.006 804.114 211.658ZM824.387 207.308V204.553H818.587V198.028H815.397V204.553H809.626V207.308H815.397V214.5H818.587V207.308H824.387ZM844.892 212.992L843.79 211.89C843.471 212.18 843.181 212.383 842.746 212.383C842.137 212.383 841.673 211.861 841.383 211.426L839.179 208.294H841.934V198.028H831.175V214.5H834.307V208.294H835.699L838.483 212.615C839.469 214.152 840.629 214.79 842.05 214.79C843.79 214.79 844.718 213.224 844.892 212.992ZM838.947 205.858H834.307V200.609H838.947V205.858ZM854.517 214.5V198.028H851.385V214.5H854.517ZM873.501 214.5V211.745H866.28V207.54H871.384V204.814H866.28V200.783H873.124V198.028H863.148V214.5H873.501ZM892.457 211.658L883.873 201.073C884.134 200.928 885.323 200.319 887.208 200.319C889.586 200.319 891.442 201.189 891.935 201.421V198.492C891.558 198.289 889.702 197.535 887.237 197.535C882.626 197.535 880.248 200.435 879.784 200.928L888.281 211.397C887.788 211.6 886.57 212.209 884.888 212.209C882.655 212.209 880.799 211.31 880.103 211.049V214.036C880.625 214.239 882.336 214.993 884.888 214.993C889.673 214.993 892.138 212.006 892.457 211.658ZM903.421 214.5C903.421 212.876 902.406 211.687 901.594 210.991L900.956 210.469L898.897 212.557C898.897 212.557 900.898 214.123 900.898 215.689C900.898 217.487 899.651 218.531 899.013 218.937V219.517C899.535 219.372 903.421 218.299 903.421 214.5ZM932.093 214.5V211.774H923.683V198.028H920.551V214.5H932.093ZM950.288 214.5V211.774H941.878V198.028H938.746V214.5H950.288ZM971.18 213.833V210.788C970.513 211.049 968.309 212.209 965.438 212.209C962.19 212.209 959.406 209.715 959.406 206.264C959.406 202.755 962.335 200.29 965.67 200.29C968.28 200.29 970.542 201.45 971.18 201.769V198.666C970.6 198.434 968.541 197.535 965.293 197.535C960.392 197.535 956.013 201.189 956.013 206.293C956.013 211.397 960.421 214.993 965.293 214.993C968.744 214.993 970.629 214.065 971.18 213.833Z"
												fill="black"
											/>
										</svg>
										
											
									</g>
								</PrintLetter>

								<!-- INSTAGRAM POST VERTICAL -->
								<PrintLetter
									w="1080"
									h="1080"
									dx="0"
									dy="-270"
									qrx="0"
									qry="1620"
									namex="20"
									namey="2000"
									display={false}
									buttonName="Instagram Post"
									fileName={router.params.id}
									backgroundColor="#000"
									{...parseDemon(router.params.id)}
								>
									<g slot="demon">
										<!-- Instagram Post Sizes -->
										<Demon
											w="1080"
											h="1620"
											ds=".75"
											dw="379.36"
											dh="511.86"
											dx="351"
											dy="500"
											{...parseDemon(router.params.id)}
										/>
									</g>
									<g slot="qr"> /> </g>
								</PrintLetter>

								<!-- NFT -->
								<PrintLetter
									w="4040"
									h="6060"
									dx="0"
									dy="0"
									qrx="0"
									qry="0"
									namex="0"
									namey="0"
									buttonName="High Resolution/No Border"
									fileName={router.params.id}
									{...parseDemon(router.params.id)}
								>
									<g slot="demon">
										<Demon
											w="4040"
											h="6060"
											ds="1"
											dw="1782"
											dh="2400"
											dx="1130"
											dy="1594.4"
											{...parseDemon(router.params.id)}
										/>
									</g>
								</PrintLetter>
							</div>
						{/if}
					</div>
				</div>
			</div></Route
		>
	</Router>
</div>

<style global lang="postcss">
	button {
		@apply text-black border-0;
	}

	/* purgecss start ignore */

	@tailwind base;
	@tailwind components;

	/*purgecss end ignore*/

	@tailwind utilities;

	.frame {
		border: 24px solid black;
		box-shadow: 0 10px 7px -5px rgba(0, 0, 0, 0.3);
	}

	.frame.small {
		border: 10px solid black;
	}

	.mat {
		background: white;
		padding: 8%;
		box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.5) inset;
	}

	.art {
		position: relative;
	}

	.art.innershadow:after {
		content: "";
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		display: block;
		box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.5) inset;
	}
</style>
